export const locale = {
    lang: 'es',
    data: {
      'RESULTADOS': {
        'TITULO': 'RESULTADOS',
        'DESCRIP': 'Selecciona una opción',
        'CARGANDO': 'Cargando los resultados de la encuesta de la empresa',
        'COMINGSOON': 'Resultados de la encuesta COVID próximamente...',
        'VALIDANDO': {
          'BOTON': 'En proceso de validación',
          'MENSAJE': 'Los resultados de este producto se encuentran en proceso de validación, próximamente serán puestos a su disposición',
        },
        'TABLAPRODUCTOS':{
          'COL1':'Año',
          'COL2':'Acceso',
          'BOT':'Acceso',
        },

        'SECCIONES': {
          'TITULO_VER':'Versión ',
          'NOSECCIONES': 'No hay secciones disponibles',
          'CERTIFICAR': {
            'TITULO': 'Izzi',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'MEDIR': {
            'TITULO': 'MEDIR',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          },
          'PULSE': {
            'TITULO': 'PULSE CHECK',
            'INFO': 'Selecciona el año que quieras consultar',
            'BOTON': 'Entrar'
          }
        },
        'TABPRIN':{
          'TABPRO':'Proceso de Izzi',
          'TAB4ALL':'Resultados FORALL',
          'TAB4ALL2':'Proceso de FORALL',
          'TITURES':'Resultados FORALL',
          'TABCER':'Procesos de medir',
          'TABPULSE':'Procesos de pulse check',


        },
        '4ALLVIEJAS':{
         'TITULO': 'FORALL resultados heredados',
         'BOTON': 'Iniciar',
         'SIN_4ALL_HEREDADAS':'Usted no cuenta con resultados heredados de FORALL',
         'TITULOCERTIFICAR':'Certificar',
         'APLICACIONANIO':'Año de aplicación: 2019',
        },
        '4ALL':{
             'CARGANDO':'Cargando resultados FORALL',
             'TITULO4ALL':'RESULTADOS DE PRÁCTICAS',
             'TABPRACTICAS':{
              'TITULOTAB':'Prácticas 4all',
              'TITULOPRACGLOBAL':{
              'SUBTITULOPRAC':'Resultado global de prácticas FORALL',
              'TEXTO1':'Porcentaje de ',
              'TEXTO2':'conocimiento de las prácticas FORALL',
              'TEXTO3':'en tu organización',
              'TEXTO4':'Nivel de',
              'TEXTO5':'satisfacción de los colaboradores que conocen',
              'TEXTO6':'las prácticas FORALL',
            },
            'TITULOPRAC4All':{
              'TITULOTAB':'Demograficos',
              'SUBTITULO4ALL':'Resultados por prácticas FORALL',
              'TITULOCONO':'CONOCIMIENTO',
              'TEXTO1':'Porcentaje de conocimiento de las prácticas FORALL en tu organización',
              'TITULOSATIS':'SATISFACCIÓN',
              'TEXTO2':'Nivel de satisfacción de los colaboradores que conocen la práctica FORALL',
            },
          },

      'DEMOGRAFICOS':{
        'Cargo homologado ': 'Cargo Homologado ',
        'Años de Trabajo': 'Antiguedad',
        'Condición de trabajo': 'Condición de trabajo',
        'Tipo de trabajo': 'Esquema Compensacion',
        'Género': 'Genero',
        'Educación': 'Grado Academico',
        'PORCONOTXT1': 'Porcentaje de',
        'PORCONOTXT2': 'conocimiento de las prácticas FORALL',
        'PORCONOTXT3': 'por corte demográfico',
        'PORSATITXT1': 'Nivel de',
        'PORSATITXT2': 'satisfacción de los colaboradores que conocen las prácticas FORALL',
        'PORSATITXT3': 'por corte demográfico',
       }
         },
       }
    }
};
